export default "__VITE_PUBLIC_ASSET__4d86b9ad__"